
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

import "./PharmacyOrderDetails.css";


import {
    getPharmacyOrder,
    applyPharmacyCoupon,
    removePharmacyCoupon,
} from "../../services/pharmacy/pharmacyOrderService";


import PrescriptionOrderStepper from "../Dashboard/Pharmacy/components/PrescriptionOrderStepper";
import {
    Package,
    MapPin,
    Phone,
    UserRound,
    FileText,
    Pill,
    ShieldCheck,
    Image as ImageIcon,
    TicketPercent,
    Truck,
    CreditCard,
    CalendarDays,
    Hash,
    CheckCircle2,
} from "lucide-react";

import "./PharmacyOrderDetails.css";
import api from "../../services/api";
import toast from "react-hot-toast";
export default function PharmacyOrderDetails( ) {
    const { id } = useParams();

    const [orderData, setOrderData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    const [couponCode, setCouponCode] = useState("");
    const [couponLoading, setCouponLoading] = useState(false);
    const [couponMessage, setCouponMessage] = useState("");
    const [paymentLoading, setPaymentLoading] = useState(false);
const navigate = useNavigate();

    useEffect(() => {
        loadOrder();
    }, [id]);

    const loadOrder = async () => {
        try {
            setLoading(true);
            setError("");

            const result = await getPharmacyOrder(id);

            setOrderData(result);

        } catch (err) {
            console.error("Load pharmacy order:", err);

            setError(
                err.response?.data?.message ||
                "امکان دریافت اطلاعات سفارش وجود ندارد."
            );

        } finally {
            setLoading(false);
        }
    };

    const formatPrice = (value) => {
        return Number(value || 0).toLocaleString("en-US");
    };

    const formatDate = (date) => {
        if (!date) return "-";

        return new Date(date).toLocaleDateString("fa-IR");
    };

    const getStatusText = (status) => {
        const statuses = {
            0: "در انتظار بررسی",
            1: "در انتظار پرداخت",
            2: "آماده سازی",
            3: "در حال ارسال",
            4: "تکمیل شده",
            6: "لغو شده",
        };

        return statuses[status] || "نامشخص";
    };

    const getInsuranceName = (type) => {
        return Number(type) === 0
            ? "تامین اجتماعی"
            : "سلامت";
    };




    if (loading) {
        return (
            <section className="pharmacy-details-page" dir="rtl">
                <div className="pharmacy-details-loading">
                    <span className="prescription-spinner" />
                    <p>در حال دریافت اطلاعات سفارش...</p>
                </div>
            </section>
        );
    }

    if (error || !orderData) {
        return (
            <section className="pharmacy-details-page" dir="rtl">
                <div className="pharmacy-details-error">
                    <Package size={35} />
                    <p>{error || "سفارش مورد نظر پیدا نشد."}</p>
                    <button onClick={loadOrder}>تلاش مجدد</button>
                </div>
            </section>
        );
    }

    const handlePayment = async () => {
        if (!order || Number(order.amount) <= 0) return;

        try {
            setPaymentLoading(true);

            // Replace this endpoint with your actual payment API.
            const response = await api.post(
                `/pharmacy/orders/${order.id}/payment`
            );

            const paymentUrl = response.data?.data?.payment_url;

            if (paymentUrl) {
                window.location.href = paymentUrl;
            } else {
                toast.error("آدرس درگاه پرداخت دریافت نشد.");
            }
        } catch (error) {
            toast.error(
                error.response?.data?.message || "خطا در اتصال به درگاه پرداخت"
            );
        } finally {
            setPaymentLoading(false);
        }
    };

    const { order, address, items } = orderData;

    const orderStatus = Number(order?.status);

    const isOrderProcessed = [2, 3, 4].includes(orderStatus);

    const currentStep = {
        0: 1, // در انتظار بررسی
        1: 2, // در انتظار پرداخت
        2: 3, // آماده سازی
        3: 4, // در حال ارسال
        4: 5, // تکمیل شده
    }[orderStatus] || 1;

    const orderAmount = Number(order?.amount ?? 0);
    const canPay = orderAmount > 0;
    const canApplyCoupon = Number(order?.amount ?? 0) > 0;

    const couponApplied =
        Boolean(order?.coupon?.length) ||
        Number(order?.coupon ?? 0) > 0;

    const handleCouponAction = async () => {
        if (!order || !canApplyCoupon || couponLoading) return;

        try {
            setCouponLoading(true);

            if (couponApplied) {
                const response = await removePharmacyCoupon(order.id);

                if (response.success) {
                    await loadOrder();
                    setCouponCode("");
                    toast.success("کد تخفیف حذف شد.");
                }

                return;
            }

            if (!couponCode.trim()) {
                toast.error("لطفاً کد تخفیف را وارد کنید.");
                return;
            }

            const response = await applyPharmacyCoupon(
                order.id,
                couponCode.trim()
            );

            if (response.success) {
                await loadOrder();
                // setCouponCode("");
                toast.success("کد تخفیف با موفقیت اعمال شد.");
            }

        } catch (error) {
            console.error("Coupon error:", error);

            toast.error(
                error.response?.data?.message ||
                "عملیات کد تخفیف انجام نشد."
            );

        } finally {
            setCouponLoading(false);
        }
    };

    return (
        <section className="pharmacy-details-page" dir="rtl">

            {/* Stepper */}
            <PrescriptionOrderStepper currentStep={currentStep} />

            {/* Page heading */}
            <div className="pharmacy-details-heading">
                <div>
                    <h2>جزئیات سفارش</h2>
                    <p>اطلاعات سفارش دارویی شما</p>
                </div>

                <span className="pharmacy-order-status">
                    <CheckCircle2 size={16} />
                    {getStatusText(order.status)}
                </span>
            </div>

            <div className="pharmacy-details-layout">

                <div className="pharmacy-details-main">

                    {/* Order information */}
                    <div className="pharmacy-details-card">

                        <div className="pharmacy-details-card-title">
                            <div className="pharmacy-details-title-icon">
                                <Package size={20} />
                            </div>

                            <div>
                                <h3>اطلاعات سفارش</h3>
                                <p>مشخصات ثبت سفارش</p>
                            </div>
                        </div>

                        <div className="pharmacy-order-info-grid">

                            <div>
                                <span>شماره سفارش</span>
                                <strong dir="rtl">{order.id}</strong>
                            </div>

                            <div>
                                <span>تاریخ ثبت</span>
                                <strong>
                                    <CalendarDays size={15} />
                                    {formatDate(order.created_at)}
                                </strong>
                            </div>

                            <div>
                                <span>وضعیت سفارش</span>
                                <strong>{getStatusText(order.status)}</strong>
                            </div>

                        </div>
                    </div>

                    {/* Address */}
                    <div className="pharmacy-details-card">

                        <div className="pharmacy-details-card-title">
                            <div className="pharmacy-details-title-icon">
                                <MapPin size={20} />
                            </div>

                            <div>
                                <h3>آدرس تحویل</h3>
                                <p>آدرس انتخاب‌شده برای ارسال سفارش</p>
                            </div>
                        </div>

                        {address ? (
                            <div className="pharmacy-address-content">

                                <div className="pharmacy-address-name">
                                    <UserRound size={17} />

                                    <strong>
                                        {address.name} {address.lname}
                                    </strong>
                                </div>

                                <div className="pharmacy-address-row">
                                    <MapPin size={16} />
                                    <span>{address.address}</span>
                                </div>

                                <div className="pharmacy-address-row">
                                    <Phone size={16} />
                                    <span dir="ltr">{address.mobile}</span>
                                </div>

                                <div className="pharmacy-address-row">
                                    <Hash size={16} />
                                    <span>
                                        کد پستی: {address.postalCode || "-"}
                                    </span>
                                </div>

                            </div>
                        ) : (
                            <p>آدرسی برای این سفارش ثبت نشده است.</p>
                        )}
                    </div>

                    {/* Order items */}
                    <div className="pharmacy-details-card">

                        <div className="pharmacy-details-card-title">
                            <div className="pharmacy-details-title-icon">
                                <FileText size={20} />
                            </div>

                            <div>
                                <h3>اقلام سفارش</h3>
                                <p>جزئیات نسخه‌ها و داروهای درخواستی</p>
                            </div>
                        </div>

                        {/* Image prescriptions */}
                        {items.prescriptions?.length > 0 && (
                            <div className="pharmacy-detail-group">

                                <div className="pharmacy-detail-group-title">
                                    <ImageIcon size={18} />
                                    <h4>نسخه‌های تصویری</h4>
                                </div>

                                {items.prescriptions.map((item) => (
                                    <div
                                        className="pharmacy-detail-item"
                                        key={item.id}
                                    >
                                        <div className="pharmacy-detail-item-info">
                                            <strong>تصویر نسخه</strong>
                                            <span>نسخه بارگذاری‌شده</span>
                                        </div>

                                        {item.file_url && (

                                            <a
                                                href={`data:image/jpeg;base64,${item.file_url}`}
                                                target="_blank"
                                                rel="noreferrer"
                                                className="pharmacy-image-link"
                                            >
                                                <img
                                                    // src={item.file_url}
                                                    src={`data:image/jpeg;base64,${item.file_url}`}
                                                    alt="Prescription"
                                                />
                                                <span>مشاهده نسخه</span>
                                            </a>
                                        )}
                                    </div>
                                ))}

                            </div>
                        )}

                        {/* OTC */}
                        {items.nonprescriptions?.length > 0 && (
                            <div className="pharmacy-detail-group">

                                <div className="pharmacy-detail-group-title">
                                    <Pill size={18} />
                                    <h4>داروهای بدون نسخه</h4>
                                </div>

                                {items.nonprescriptions.map((item) => (
                                    <div
                                        className="pharmacy-detail-item"
                                        key={item.id}
                                    >
                                        <div className="pharmacy-detail-item-info">
                                            <strong>{item.productName}</strong>

                                            <span>
                                                تعداد: {item.count}
                                                {item.productDose
                                                    ? ` | دوز: ${item.productDose}`
                                                    : ""}
                                            </span>

                                            <span>
                                                نوع محصول: {item.drug_type_name || "-"}
                                                {" | "}
                                                واحد: {item.unit_name || "-"}
                                            </span>
                                        </div>

                                        {item.file_url && (
                                            <a
                                                href={`data:image/jpeg;base64,${item.file_url}`}
                                                target="_blank"
                                                rel="noreferrer"
                                                className="pharmacy-image-link"
                                            >
                                                <img
                                                    src={`data:image/jpeg;base64,${item.file_url}`}
                                                    alt={item.productName}
                                                />
                                                <span>مشاهده تصویر</span>
                                            </a>
                                        )}
                                    </div>
                                ))}

                            </div>
                        )}

                        {/* Electronic prescriptions */}
                        {items.eprescriptions?.length > 0 && (
                            <div className="pharmacy-detail-group">

                                <div className="pharmacy-detail-group-title">
                                    <ShieldCheck size={18} />
                                    <h4>نسخه الکترونیکی بیمه</h4>
                                </div>

                                {items.eprescriptions.map((item) => (
                                    <div
                                        className="pharmacy-detail-item"
                                        key={item.id}
                                    >
                                        <div className="pharmacy-detail-item-info">
                                            <strong>
                                                بیمه {getInsuranceName(item.type)}
                                            </strong>

                                            <span>
                                                کد ملی: {item.national_code}
                                            </span>

                                            <span>
                                                نام پزشک: {item.doctor_name}
                                            </span>

                                            {item.tracking_code && (
                                                <span>
                                                    کد رهگیری: {item.tracking_code}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                ))}

                            </div>
                        )}

                        {!items.prescriptions?.length &&
                            !items.nonprescriptions?.length &&
                            !items.eprescriptions?.length && (
                                <p className="pharmacy-no-items">
                                    اطلاعات اقلام سفارش موجود نیست.
                                </p>
                            )}

                    </div>

                    {/* Comment */}
                    {order.description && (
                        <div className="pharmacy-details-card">

                            <div className="pharmacy-details-card-title">
                                <div className="pharmacy-details-title-icon">
                                    <FileText size={20} />
                                </div>

                                <div>
                                    <h3>توضیحات سفارش</h3>
                                </div>
                            </div>

                            <p className="pharmacy-order-description">
                                {order.description}
                            </p>
                        </div>
                    )}

                </div>

                {/* Price sidebar */}
                <aside className="pharmacy-details-sidebar">

                    <div className="pharmacy-details-card pharmacy-price-card">

                        <div className="pharmacy-details-card-title">
                            <div className="pharmacy-details-title-icon">
                                <CreditCard size={20} />
                            </div>

                            <div>
                                <h3>صورتحساب</h3>
                                <p>مبلغ نهایی سفارش</p>
                            </div>
                        </div>

                        <div className="pharmacy-price-row">
                            <span>مبلغ سفارش</span>
                            <strong>
                                {formatPrice(order.amount)} تومان
                            </strong>
                        </div>

                        <div className="pharmacy-price-row">
                            <span>
                                <Truck size={15} />
                                هزینه ارسال
                            </span>
                            <strong>
                                {formatPrice(order.shipping)} تومان
                            </strong>
                        </div>

                        {/* <div className="pharmacy-price-row discount-row">
                            <span>تخفیف</span>
                            <strong>
                                {formatPrice(order.discount)} تومان
                            </strong>
                        </div> */}

                        <div className="pharmacy-price-row discount-row">
                            <span>تخفیف کوپن</span>
                            <strong>
                                {formatPrice(order.coupon)} تومان
                            </strong>
                        </div>

                        {/* <div className="pharmacy-price-row">
                            <span>اعتبار کیف پول</span>
                            <strong>
                                {formatPrice(order.wallet)} تومان
                            </strong>
                        </div> */}

                        <div className="pharmacy-price-divider" />

                        <div className="pharmacy-total-row">
                            <span>مبلغ قابل پرداخت</span>
                            <strong>
                                {formatPrice(order.total)} تومان
                            </strong>
                        </div>


                        {/* Coupon */}


                        {!isOrderProcessed && (
                            <div className="pharmacy-coupon-box">
                                <h4>کد تخفیف</h4>

                                <div className="pharmacy-coupon-input">
                                    <input
                                        type="text"
                                        value={couponCode}
                                        onChange={(e) => setCouponCode(e.target.value)}
                                        placeholder="کد تخفیف را وارد کنید"
                                        disabled={!canApplyCoupon || couponApplied || couponLoading}
                                    />

                                    <button
                                        type="button"
                                        onClick={handleCouponAction}
                                        disabled={
                                            !canApplyCoupon ||
                                            couponLoading ||
                                            (!couponApplied && !couponCode.trim())
                                        }
                                    >
                                        {couponLoading
                                            ? "لطفاً صبر کنید..."
                                            : couponApplied
                                                ? "حذف کد تخفیف"
                                                : "اعمال کد تخفیف"}
                                    </button>
                                </div>

                                {!canApplyCoupon && (
                                    <p className="pharmacy-coupon-message">
                                        ابتدا مبلغ سفارش باید توسط داروخانه مشخص شود.
                                    </p>
                                )}
                            </div>
                        )}


                        {canPay && !isOrderProcessed && (
                            <button
                                type="button"
                                className="pharmacy-payment-button"
                                onClick={handlePayment}
                                disabled={paymentLoading}
                            >
                                {paymentLoading ? "لطفاً صبر کنید..." : "پرداخت آنلاین"}
                            </button>
                        )}

                    </div>

                </aside>

            </div>

              {/* Footer buttons */}

         <div className="pharmacy-details-back">
    <button
        type="button"
        onClick={() => navigate("/dashboard/pharmacy/prescription")}
    >
       بازگشت به نسخه های من
    </button>
</div>

        </section>
    );
}
